import { render, staticRenderFns } from "./whiteUfw.vue?vue&type=template&id=6f890242&scoped=true"
import script from "./whiteUfw.vue?vue&type=script&lang=js"
export * from "./whiteUfw.vue?vue&type=script&lang=js"
import style0 from "./whiteUfw.vue?vue&type=style&index=0&id=6f890242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f890242",
  null
  
)

export default component.exports